export const translates = {
  notifications: {
    contactUsForm: {
      success: {
        title: `Ваша заявка была отправлена`,
        description: `Мы скоро с Вами свяжемся. Спрасибо за обращение.`
      },
      error: {
        title: `Неизвестная ошибка`,
        description: `Поажулайста, напишите нам на электронный адрес hello@intspirit.com`
      }
    },
    vacancyForm: {
      success: {
        title: `Ваша заявка была отправлена`,
        description: `Мы скоро с Вами свяжемся. Спрасибо за обращение.`
      },
      error: {
        title: `Неизвестная ошибка`,
        description: `Поажулайста, напишите нам на электронный адрес hello@intspirit.com`
      }
    }
  }
}
